import { checkForSignedInConnection } from '../../arcGIS/arcgis-connection-checker';

const ArcGISLogout = async (esriApiKey: string, connectors: any[], callback: () => void) => {
  try {
    const connection = await checkForSignedInConnection(esriApiKey, connectors, false);
    if (connection) {
      connection.destroyCredentials();
    }
  } finally {
    callback();
  }
};

export default ArcGISLogout;
